import { jsx as _jsx } from "react/jsx-runtime";
import { Activity, AlarmClock, ArrowDown, ArrowUp, ArrowUpDown, ArrowUpRight, Award, Bell, BellOff, BookOpen, CalendarDays, CarFront, ChartColumn, Check, ChevronDown, ChevronLeft, ChevronRight, CircleCheck, CircleHelp, ClipboardCheck, Clock, Cloud, Coffee, Copy, CreditCard, Download, Droplet, Ellipsis, EllipsisVertical, Eye, FileText, Flag, Flame, Fuel, Funnel, Gauge, GraduationCap, GripVertical, Heart, Hourglass, House, IdCard, Image, Inbox, Layers, LayoutGrid, List, Lock, LogOut, Mail, MapPin, MessageSquare, Moon, Package, Palette, Pause, Pencil, Percent, Play, Plus, PoundSterling, RadioTower, ReceiptText, RefreshCw, ScanBarcode, Search, Send, Settings, ShieldCheck, ShoppingBasket, SlidersHorizontal, Sparkles, Star, Sun, Tag, Target, ThumbsUp, Trash2, TrendingDown, TrendingUp, TriangleAlert, Truck, Tv, Undo2, Upload, User, Users, Volume2, Wrench, X, Zap } from "lucide-react";
const LUCIDE = {
    home: House,
    wrench: Wrench,
    box: Package,
    pin: MapPin,
    settings: Settings,
    users: Users,
    palette: Palette,
    message: MessageSquare,
    user: User,
    chart: ChartColumn,
    pound: PoundSterling,
    target: Target,
    percent: Percent,
    bell: Bell,
    plus: Plus,
    arrow: ArrowUpRight,
    fuel: Fuel,
    basket: ShoppingBasket,
    truck: Truck,
    clock: Clock,
    check: Check,
    layers: Layers,
    pulse: Activity,
    card: CreditCard,
    upload: Upload,
    download: Download,
    scan: ScanBarcode,
    more: Ellipsis,
    calendar: CalendarDays,
    tasks: ClipboardCheck,
    mute: BellOff,
    flag: Flag,
    shield: ShieldCheck,
    alert: TriangleAlert,
    flame: Flame,
    tag: Tag,
    "trending-up": TrendingUp,
    "trending-down": TrendingDown,
    broadcast: RadioTower,
    grid: LayoutGrid,
    "check-circle": CircleCheck,
    droplet: Droplet,
    "alert-triangle": TriangleAlert,
    gauge: Gauge,
    mail: Mail,
    book: BookOpen,
    graduation: GraduationCap,
    receipt: ReceiptText,
    sun: Sun,
    file: FileText,
    lock: Lock,
    play: Play,
    image: Image,
    x: X,
    "chevron-left": ChevronLeft,
    "chevron-right": ChevronRight,
    "chevron-down": ChevronDown,
    volume: Volume2,
    star: Star,
    sparkle: Sparkles,
    tv: Tv,
    list: List,
    trash: Trash2,
    copy: Copy,
    eye: Eye,
    pencil: Pencil,
    grip: GripVertical,
    refresh: RefreshCw,
    award: Award,
    "arrow-up": ArrowUp,
    "arrow-down": ArrowDown,
    thumb: ThumbsUp,
    help: CircleHelp,
    pause: Pause,
    id: IdCard,
    moon: Moon,
    logout: LogOut,
    search: Search,
    filter: Funnel,
    inbox: Inbox,
    zap: Zap,
    cloud: Cloud,
    coffee: Coffee,
    car: CarFront,
    heart: Heart,
    hourglass: Hourglass,
    sliders: SlidersHorizontal,
    sort: ArrowUpDown,
    dots: EllipsisVertical,
    send: Send,
    undo: Undo2,
    snooze: AlarmClock,
};
const PATHS = {
    home: "M4 11.5 12 5l8 6.5V19a1 1 0 0 1-1 1h-4.5v-5.5h-5V20H5a1 1 0 0 1-1-1z",
    wrench: "M14.5 5.5a4 4 0 0 0 4.9 4.9l-8.7 8.7a2.1 2.1 0 0 1-3-3l8.7-8.7a4 4 0 0 0-1.9-1.9zM17 4l-2 2 1 2 2 1 2-2",
    box: "M4 8l8-4 8 4v8l-8 4-8-4zM4 8l8 4 8-4M12 12v8",
    pin: "M12 21s-6.5-6.1-6.5-11a6.5 6.5 0 0 1 13 0c0 4.9-6.5 11-6.5 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    settings: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 13.5l1.6 1.2-2 3.4-1.9-.7a7 7 0 0 1-2.1 1.2L14.7 21h-4l-.4-2.4a7 7 0 0 1-2.1-1.2l-1.9.7-2-3.4 1.6-1.2a7 7 0 0 1 0-2.9L4.3 9.3l2-3.4 1.9.7a7 7 0 0 1 2.1-1.2L10.7 3h4l.4 2.4a7 7 0 0 1 2.1 1.2l1.9-.7 2 3.4-1.6 1.2a7 7 0 0 1 0 2.9z",
    users: "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20a6.5 6.5 0 0 1 13 0M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14.2a6.5 6.5 0 0 1 3.5 5.8",
    palette: "M12 3a9 9 0 1 0 0 18c1.2 0 1.8-.9 1.5-2-.4-1.4.6-2.5 2-2.5H18a3 3 0 0 0 3-3A9 9 0 0 0 12 3zM7.5 12.5h.01M9.5 8h.01M14.5 8h.01",
    message: "M4 5h16v11H9l-5 4z",
    user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4.5 20.5a7.5 7.5 0 0 1 15 0",
    chart: "M4 20V4M4 20h16M8 16v-5M12 16V8M16 16v-3",
    pound: "M16 6.5A3.5 3.5 0 0 0 9.5 8v4.5c0 3-1.5 5.5-3 6.5H17M7 12.5h7",
    target: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 12h.01",
    percent: "M19 5 5 19M7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM16.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    bell: "M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20.5a2.2 2.2 0 0 0 4 0",
    plus: "M12 5v14M5 12h14",
    arrow: "M7 17 17 7M9 7h8v8",
    fuel: "M5 20V5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v15M4 20h11M7 8h5M14 10h2a1.5 1.5 0 0 1 1.5 1.5V16a1.5 1.5 0 0 0 3 0V8l-2.5-2.5",
    basket: "M3 9h18l-2 10H5zM8 9l3-5M16 9l-3-5M9 13v3M15 13v3",
    truck: "M3 6h11v10H3zM14 9h4l3 3v4h-7M7 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM17 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2",
    check: "M5 12.5 10 17l9-10",
    layers: "M12 3 3 8l9 5 9-5zM3 13l9 5 9-5",
    pulse: "M3 12h4l2-5 4 10 2-5h6",
    card: "M3 6h18v12H3zM3 10h18M7 15h3",
    upload: "M12 16V4M7 9l5-5 5 5M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3",
    download: "M12 4v12M7 11l5 5 5-5M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3",
    scan: "M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3M7 12h10",
    more: "M5 12h.01M12 12h.01M19 12h.01",
    calendar: "M4 6h16v14H4zM4 10h16M8 3v4M16 3v4",
    tasks: "M9 3.5h6v3H9zM7.5 5H6a1.5 1.5 0 0 0-1.5 1.5v13A1.5 1.5 0 0 0 6 21h12a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 18 5h-1.5M8.5 13.5l2.5 2.5 4.5-5",
    mute: "M6 16V11a6 6 0 0 1 9.5-4.9M18 10.5V16l1.5 2H8M10 20.5a2.2 2.2 0 0 0 4 0M4 4l16 16",
    flag: "M5 21V4M5 4h11l-2 4 2 4H5",
    shield: "M12 3 4.5 6v5.5c0 4.6 3.2 8.3 7.5 9.5 4.3-1.2 7.5-4.9 7.5-9.5V6L12 3ZM8.5 12l2.5 2.5 4.5-5",
    alert: "M12 3.5 2.5 20h19L12 3.5ZM12 10v4.5M12 17.2v.3",
    flame: "M12 21c-3.9 0-6.5-2.7-6.5-6.2 0-3.3 2.3-5.2 3.6-7.3.4 1.6 1.3 2.7 2.4 3.2C11.4 7.5 12.4 5 15 3c-.3 2.6.7 4.6 2 6.3 1 1.4 1.5 3 1.5 4.9 0 3.9-2.6 6.8-6.5 6.8Zm0 0c-1.6 0-2.7-1.1-2.7-2.6 0-1.7 1.4-2.6 2.7-4.4 1.3 1.8 2.7 2.7 2.7 4.4 0 1.5-1.1 2.6-2.7 2.6Z",
    tag: "M3.5 12.5V4.5a1 1 0 0 1 1-1h8l8 8-9 9zM8 8.5h.01",
    "trending-up": "M3 17l6-6 4 4 8-8M15 7h6v6",
    "trending-down": "M3 7l6 6 4-4 8 8M15 17h6v-6",
    broadcast: "M12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM8.5 15.5a5 5 0 0 1 0-7M15.5 8.5a5 5 0 0 1 0 7M5.6 18.4a9 9 0 0 1 0-12.8M18.4 5.6a9 9 0 0 1 0 12.8",
    grid: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
    "check-circle": "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8 12.5l3 3 5-6",
    droplet: "M12 3.5s-6 6.6-6 11a6 6 0 0 0 12 0c0-4.4-6-11-6-11z",
    "alert-triangle": "M12 3.5 2.5 20h19L12 3.5ZM12 10v4.5M12 17.2v.3",
    gauge: "M4.5 17a8 8 0 1 1 15 0M12 13l3.5-4M12 13h.01",
    mail: "M3.5 6h17v12h-17zM3.5 6.5l8.5 6.5 8.5-6.5",
    book: "M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5zM4 20.5A2.5 2.5 0 0 0 6.5 23H20v-5M8 7h8M8 10.5h6",
    graduation: "M2.5 9 12 4.5 21.5 9 12 13.5zM6.5 11v4.5c0 1.5 2.5 3 5.5 3s5.5-1.5 5.5-3V11M21.5 9v5",
    receipt: "M6 3h12v18l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5L6 21zM9 8h6M9 11.5h6M9 15h4",
    sun: "M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM12 2.5V4.5M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4",
    file: "M6 3h8l4 4v14H6zM14 3v4h4M9 12h6M9 15.5h6",
    lock: "M6 11h12v10H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3M12 15v2.5",
    play: "M8 5.5v13l10-6.5z",
    image: "M4 5h16v14H4zM4 16l4.5-4.5 3.5 3.5 2.5-2.5L20 17M15.5 9.5h.01",
    x: "M6 6l12 12M18 6 6 18",
    "chevron-left": "M15 5l-7 7 7 7",
    "chevron-right": "M9 5l7 7-7 7",
    "chevron-down": "M5 9l7 7 7-7",
    volume: "M4 9.5h3.5L12 5.5v13l-4.5-4H4zM15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11",
    star: "M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L12 16.9l-5.2 2.8 1-5.9-4.3-4.1 5.9-.8z",
    sparkle: "M12 3.5l1.8 5 5 1.8-5 1.8-1.8 5-1.8-5-5-1.8 5-1.8zM18.5 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z",
    list: "M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01",
    trash: "M4.5 7h15M10 11v6M14 11v6M6.5 7l1 13h9l1-13M9.5 7V4.5h5V7",
    copy: "M8.5 8.5h11v11h-11zM5 15.5H4.5v-11h11V5",
    eye: "M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12zM12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    pencil: "M4 20l1-4.5L16 4.5l3.5 3.5L8.5 19zM14 7l3 3",
    grip: "M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01",
    refresh: "M19.5 12a7.5 7.5 0 1 1-2.2-5.3M19.5 4.5v4h-4",
    award: "M12 14.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM8.5 13.5 7 21l5-2.5 5 2.5-1.5-7.5",
    "arrow-up": "M12 19V5M6 11l6-6 6 6",
    "arrow-down": "M12 5v14M6 13l6 6 6-6",
    thumb: "M7 10.5V20H4v-9.5zM7 10.5l4-7c1.4 0 2.3 1 2 2.5L12.5 9.5h6a1.5 1.5 0 0 1 1.5 1.8l-1.4 7.2a2 2 0 0 1-2 1.5H7",
    help: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .9-1 1.6v.6M12 17h.01",
    pause: "M8 5.5v13M16 5.5v13",
    id: "M3.5 5.5h17v13h-17zM9 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM5.8 16a3.4 3.4 0 0 1 6.4 0M14.5 9.5h3.5M14.5 13h3.5",
    moon: "M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z",
    logout: "M14 4.5h4a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-4M10 16.5 5.5 12 10 7.5M5.5 12H15",
    search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4",
    filter: "M4 5h16l-6 7.5V19l-4-2v-4.5z",
    inbox: "M3.5 13.5 6 5h12l2.5 8.5V19a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1zM3.5 13.5h5l1.5 2.5h4l1.5-2.5h5",
    zap: "M13 2.5 4.5 13.5H12l-1 8 8.5-11H12z",
    cloud: "M7 18.5a4.5 4.5 0 0 1-.6-9 6 6 0 0 1 11.4 1.5A3.75 3.75 0 0 1 17.5 18.5z",
    coffee: "M5 9h11v5a5 5 0 0 1-5 5h-1a5 5 0 0 1-5-5zM16 10.5h1.5a2.5 2.5 0 0 1 0 5H16M8.5 3.5c-.6.8-.6 1.7 0 2.5M12 3.5c-.6.8-.6 1.7 0 2.5",
    car: "M5 16.5V12l2-5h10l2 5v4.5M3.5 16.5h17v2h-17zM7 13.5h.01M17 13.5h.01",
    heart: "M12 20s-7.5-4.4-7.5-10A4.5 4.5 0 0 1 12 7.2 4.5 4.5 0 0 1 19.5 10c0 5.6-7.5 10-7.5 10z",
    hourglass: "M6.5 3.5h11M6.5 20.5h11M7.5 3.5c0 4 4.5 5 4.5 8.5S7.5 16.5 7.5 20.5M16.5 3.5c0 4-4.5 5-4.5 8.5s4.5 4.5 4.5 8.5",
    sliders: "M4 7h10M18 7h2M4 17h4M12 17h8M16 4.5v5M10 14.5v5",
    sort: "M7 4v16M3.5 7.5 7 4l3.5 3.5M17 20V4M13.5 16.5 17 20l3.5-3.5",
    dots: "M12 5.5h.01M12 12h.01M12 18.5h.01",
    send: "M20.5 3.5 10 14M20.5 3.5 14 20.5l-4-6.5-6.5-4z",
    undo: "M9 14 4.5 9.5 9 5M4.5 9.5H15a5 5 0 0 1 0 10h-3",
    snooze: "M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 9v4.5l2.5 1.5M5 3 2.5 5.5M19 3l2.5 2.5",
};
export function Icon({ name, size = 20, className }) {
    const L = LUCIDE[name];
    if (L)
        return _jsx(L, { className: className ?? "tc-icon", width: size, height: size, strokeWidth: 1.75, "aria-hidden": "true" });
    const d = PATHS[name];
    if (!d)
        return _jsx("span", { className: "tc-icon-dot", "aria-hidden": "true" });
    return (_jsx("svg", { className: className ?? "tc-icon", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: _jsx("path", { d: d }) }));
}
export const iconNames = [...new Set([...Object.keys(LUCIDE), ...Object.keys(PATHS)])];
